import type { PaymentProviderType } from '@subscriptions/domain/types';
import { PaymentProviders } from '@subscriptions/domain/types';

/**
 * Validated payment provider value object.
 * The empty string represents an absent/unknown provider produced by soft-validation reconstruction.
 */
export type PaymentProvider = Readonly<PaymentProviderType | ''>;

const validProviders = Object.values(PaymentProviders) as string[];

/**
 * Creates a validated PaymentProvider value object.
 *
 * @param raw - Raw provider string
 * @returns Validated PaymentProvider
 * @throws Error if provider is not a valid value
 */
export const createPaymentProvider = (raw: string): PaymentProvider => {
  if (!validProviders.includes(raw)) {
    throw new Error(`Invalid payment provider: ${raw}. Must be one of: ${validProviders.join(', ')}`);
  }
  return raw as PaymentProvider;
};
